// You can write more code here

/* START OF COMPILED CODE */

import SummerWaterParticles0 from '@/game/prefabs/World/Effects/SummerWaterParticles0';
import SummerWaterParticles2 from '@/game/prefabs/World/Effects/SummerWaterParticles2';
import SummerWaterSparkles1 from '@/game/prefabs/World/Effects/SummerWaterSparkles1';
import ForestTree1 from '@/game/prefabs/World/ForestTree1';
import Mentor1 from '@/game/prefabs/World/Mentors/Mentor1';
import Player from '@/game/prefabs/World/Player';
import Portal from '@/game/prefabs/World/Portal';
import WorldNode from '@/game/prefabs/World/WorldNode';
import TilemapScene from './TilemapScene';
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class Level5 extends TilemapScene {
  constructor() {
    super('Level5');

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {
    // forest_biome_6
    const forest_biome_6 = this.add.tilemap('forest-biome-6');
    forest_biome_6.addTilesetImage('summer forest', 'summer forest');
    forest_biome_6.addTilesetImage(
      'summer forest wang tiles',
      'summer forest wang tiles',
    );
    forest_biome_6.addTilesetImage('summer 32x32', 'summer 32x32');
    forest_biome_6.addTilesetImage('summer 16x32', 'summer 16x32');
    forest_biome_6.addTilesetImage(
      'summer water sparkles B',
      'summer water sparkles B 16x16',
    );
    forest_biome_6.addTilesetImage(
      'summer trees 80x112',
      'summer trees 80x112',
    );
    forest_biome_6.addTilesetImage('collision', 'collision & alpha');

    // terrain___summer_forest_wang_tiles_1
    forest_biome_6.createLayer(
      'terrain - summer forest wang tiles',
      ['summer forest wang tiles', 'summer forest'],
      0,
      0,
    );

    // sparkles___summer_water_sparkles_B_1
    const sparkles___summer_water_sparkles_B_1 = forest_biome_6.createLayer(
      'Sparkles - summer water sparkles B',
      ['summer water sparkles B'],
      0,
      0,
    )!;
    sparkles___summer_water_sparkles_B_1.visible = false;

    // deco_1___summer_forest_1
    forest_biome_6.createLayer(
      'deco 1 - summer forest',
      ['summer forest', 'summer 32x32'],
      0,
      0,
    );

    // tOP_foliage___summer_forest_16x
    forest_biome_6.createLayer(
      'TOP foliage - summer forest 16x32',
      ['summer 16x32'],
      0,
      0,
    );

    // cOLLISION_1
    const cOLLISION_1 = forest_biome_6.createLayer(
      'COLLISION',
      ['collision'],
      0,
      0,
    )!;
    cOLLISION_1.visible = false;

    // player
    const player = new Player(this, 128, 80);
    this.add.existing(player);

    // portal
    const portal = new Portal(this, 496, 176);
    this.add.existing(portal);

    // worldNode
    const worldNode = new WorldNode(this, 112, 192);
    this.add.existing(worldNode);

    // worldNode_1
    const worldNode_1 = new WorldNode(this, 224, 368);
    this.add.existing(worldNode_1);

    // worldNode_2
    const worldNode_2 = new WorldNode(this, 80, 464);
    this.add.existing(worldNode_2);

    // worldNode_3
    const worldNode_3 = new WorldNode(this, 240, 160);
    this.add.existing(worldNode_3);

    // worldNode_4
    const worldNode_4 = new WorldNode(this, 384, 80);
    this.add.existing(worldNode_4);

    // worldNode_5
    const worldNode_5 = new WorldNode(this, 416, 272);
    this.add.existing(worldNode_5);

    // forestTree1
    const forestTree1 = new ForestTree1(this, -16, 176);
    this.add.existing(forestTree1);

    // forestTree
    const forestTree = new ForestTree1(this, 16, 240);
    this.add.existing(forestTree);

    // forestTree_1
    const forestTree_1 = new ForestTree1(this, 48, 32);
    this.add.existing(forestTree_1);

    // forestTree_2
    const forestTree_2 = new ForestTree1(
      this,
      272,
      112,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_2);

    // forestTree_3
    const forestTree_3 = new ForestTree1(
      this,
      16,
      112,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_3);

    // forestTree_4
    const forestTree_4 = new ForestTree1(
      this,
      192,
      224,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_4);

    // forestTree_5
    const forestTree_5 = new ForestTree1(
      this,
      96,
      304,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_5);

    // forestTree_6
    const forestTree_6 = new ForestTree1(
      this,
      64,
      272,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_6);

    // forestTree_7
    const forestTree_7 = new ForestTree1(
      this,
      32,
      160,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_7);

    // forestTree_8
    const forestTree_8 = new ForestTree1(
      this,
      176,
      32,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_8);

    // forestTree_9
    const forestTree_9 = new ForestTree1(
      this,
      496,
      16,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_9);

    // waterSparkles
    const waterSparkles = this.add.container(0, 0);

    // springWaterSparkles1
    const springWaterSparkles1 = new SummerWaterSparkles1(this, 680, 56);
    springWaterSparkles1.flipX = true;
    springWaterSparkles1.flipY = true;
    waterSparkles.add(springWaterSparkles1);

    // springWaterSparkles
    const springWaterSparkles = new SummerWaterSparkles1(this, 616, 56);
    springWaterSparkles.flipX = false;
    springWaterSparkles.flipY = false;
    waterSparkles.add(springWaterSparkles);

    // springWaterSparkles_1
    const springWaterSparkles_1 = new SummerWaterSparkles1(this, 584, 88);
    springWaterSparkles_1.flipX = false;
    springWaterSparkles_1.flipY = false;
    waterSparkles.add(springWaterSparkles_1);

    // springWaterSparkles_2
    const springWaterSparkles_2 = new SummerWaterSparkles1(this, 552, 120);
    springWaterSparkles_2.flipX = false;
    springWaterSparkles_2.flipY = false;
    waterSparkles.add(springWaterSparkles_2);

    // springWaterSparkles_3
    const springWaterSparkles_3 = new SummerWaterSparkles1(this, 616, 56);
    springWaterSparkles_3.flipX = false;
    springWaterSparkles_3.flipY = false;
    waterSparkles.add(springWaterSparkles_3);

    // springWaterSparkles_4
    const springWaterSparkles_4 = new SummerWaterSparkles1(this, 584, 168);
    springWaterSparkles_4.flipX = false;
    springWaterSparkles_4.flipY = false;
    waterSparkles.add(springWaterSparkles_4);

    // springWaterSparkles_5
    const springWaterSparkles_5 = new SummerWaterSparkles1(this, 664, 120);
    springWaterSparkles_5.flipX = true;
    springWaterSparkles_5.flipY = true;
    waterSparkles.add(springWaterSparkles_5);

    // springWaterSparkles_6
    const springWaterSparkles_6 = new SummerWaterSparkles1(this, 424, 184);
    springWaterSparkles_6.flipX = false;
    springWaterSparkles_6.flipY = false;
    waterSparkles.add(springWaterSparkles_6);

    // springWaterSparkles_7
    const springWaterSparkles_7 = new SummerWaterSparkles1(this, 600, 408);
    springWaterSparkles_7.flipX = true;
    springWaterSparkles_7.flipY = true;
    waterSparkles.add(springWaterSparkles_7);

    // springWaterSparkles_8
    const springWaterSparkles_8 = new SummerWaterSparkles1(this, 344, 408);
    springWaterSparkles_8.flipX = true;
    springWaterSparkles_8.flipY = true;
    waterSparkles.add(springWaterSparkles_8);

    // springWaterSparkles_9
    const springWaterSparkles_9 = new SummerWaterSparkles1(this, 232, 456);
    springWaterSparkles_9.flipX = true;
    springWaterSparkles_9.flipY = true;
    waterSparkles.add(springWaterSparkles_9);

    // springWaterSparkles_10
    const springWaterSparkles_10 = new SummerWaterSparkles1(this, 392, 456);
    springWaterSparkles_10.flipX = false;
    springWaterSparkles_10.flipY = false;
    waterSparkles.add(springWaterSparkles_10);

    // springWaterParticles0
    const springWaterParticles0 = new SummerWaterParticles0(this, 712, 40);
    springWaterParticles0.flipX = true;
    springWaterParticles0.flipY = true;
    waterSparkles.add(springWaterParticles0);

    // springWaterParticles
    const springWaterParticles = new SummerWaterParticles0(this, 600, 104);
    springWaterParticles.flipX = false;
    springWaterParticles.flipY = false;
    waterSparkles.add(springWaterParticles);

    // springWaterParticles_1
    const springWaterParticles_1 = new SummerWaterParticles0(this, 648, 136);
    springWaterParticles_1.flipX = true;
    springWaterParticles_1.flipY = true;
    waterSparkles.add(springWaterParticles_1);

    // springWaterParticles_2
    const springWaterParticles_2 = new SummerWaterParticles0(this, 520, 120);
    springWaterParticles_2.flipX = false;
    springWaterParticles_2.flipY = false;
    waterSparkles.add(springWaterParticles_2);

    // springWaterParticles_3
    const springWaterParticles_3 = new SummerWaterParticles0(this, 584, 184);
    springWaterParticles_3.flipX = false;
    springWaterParticles_3.flipY = false;
    waterSparkles.add(springWaterParticles_3);

    // springWaterParticles_4
    const springWaterParticles_4 = new SummerWaterParticles0(this, 568, 200);
    springWaterParticles_4.flipX = false;
    springWaterParticles_4.flipY = false;
    waterSparkles.add(springWaterParticles_4);

    // springWaterParticles_5
    const springWaterParticles_5 = new SummerWaterParticles0(this, 600, 248);
    springWaterParticles_5.flipX = false;
    springWaterParticles_5.flipY = false;
    waterSparkles.add(springWaterParticles_5);

    // springWaterParticles_6
    const springWaterParticles_6 = new SummerWaterParticles0(this, 584, 264);
    springWaterParticles_6.flipX = false;
    springWaterParticles_6.flipY = false;
    waterSparkles.add(springWaterParticles_6);

    // springWaterParticles_7
    const springWaterParticles_7 = new SummerWaterParticles0(this, 488, 344);
    springWaterParticles_7.flipX = false;
    springWaterParticles_7.flipY = false;
    waterSparkles.add(springWaterParticles_7);

    // springWaterParticles_8
    const springWaterParticles_8 = new SummerWaterParticles0(this, 472, 360);
    springWaterParticles_8.flipX = false;
    springWaterParticles_8.flipY = false;
    waterSparkles.add(springWaterParticles_8);

    // springWaterParticles_9
    const springWaterParticles_9 = new SummerWaterParticles0(this, 456, 360);
    springWaterParticles_9.flipX = false;
    springWaterParticles_9.flipY = false;
    waterSparkles.add(springWaterParticles_9);

    // springWaterParticles_10
    const springWaterParticles_10 = new SummerWaterParticles0(this, 616, 392);
    springWaterParticles_10.flipX = true;
    springWaterParticles_10.flipY = true;
    waterSparkles.add(springWaterParticles_10);

    // springWaterParticles_11
    const springWaterParticles_11 = new SummerWaterParticles0(this, 408, 456);
    springWaterParticles_11.flipX = false;
    springWaterParticles_11.flipY = false;
    waterSparkles.add(springWaterParticles_11);

    // springWaterParticles_12
    const springWaterParticles_12 = new SummerWaterParticles0(this, 344, 424);
    springWaterParticles_12.flipX = true;
    springWaterParticles_12.flipY = true;
    waterSparkles.add(springWaterParticles_12);

    // springWaterParticles_13
    const springWaterParticles_13 = new SummerWaterParticles0(this, 328, 424);
    springWaterParticles_13.flipX = true;
    springWaterParticles_13.flipY = true;
    waterSparkles.add(springWaterParticles_13);

    // springWaterParticles_14
    const springWaterParticles_14 = new SummerWaterParticles0(this, 296, 424);
    springWaterParticles_14.flipX = true;
    springWaterParticles_14.flipY = true;
    waterSparkles.add(springWaterParticles_14);

    // springWaterParticles_15
    const springWaterParticles_15 = new SummerWaterParticles0(this, 232, 472);
    springWaterParticles_15.flipX = true;
    springWaterParticles_15.flipY = true;
    waterSparkles.add(springWaterParticles_15);

    // springWaterParticles2
    const springWaterParticles2 = new SummerWaterParticles2(this, 720, 24);
    springWaterParticles2.flipX = true;
    springWaterParticles2.flipY = true;
    waterSparkles.add(springWaterParticles2);

    // springWaterParticles_16
    const springWaterParticles_16 = new SummerWaterParticles2(this, 704, 72);
    springWaterParticles_16.flipX = true;
    springWaterParticles_16.flipY = true;
    waterSparkles.add(springWaterParticles_16);

    // springWaterParticles_17
    const springWaterParticles_17 = new SummerWaterParticles2(this, 688, 264);
    springWaterParticles_17.flipX = true;
    springWaterParticles_17.flipY = true;
    waterSparkles.add(springWaterParticles_17);

    // springWaterParticles_18
    const springWaterParticles_18 = new SummerWaterParticles2(this, 608, 248);
    springWaterParticles_18.flipX = false;
    springWaterParticles_18.flipY = false;
    waterSparkles.add(springWaterParticles_18);

    // springWaterParticles_19
    const springWaterParticles_19 = new SummerWaterParticles2(this, 544, 200);
    springWaterParticles_19.flipX = false;
    springWaterParticles_19.flipY = false;
    waterSparkles.add(springWaterParticles_19);

    // springWaterParticles_20
    const springWaterParticles_20 = new SummerWaterParticles2(this, 592, 168);
    springWaterParticles_20.flipX = false;
    springWaterParticles_20.flipY = false;
    waterSparkles.add(springWaterParticles_20);

    // springWaterParticles_21
    const springWaterParticles_21 = new SummerWaterParticles2(this, 608, 120);
    springWaterParticles_21.flipX = false;
    springWaterParticles_21.flipY = false;
    waterSparkles.add(springWaterParticles_21);

    // springWaterParticles_22
    const springWaterParticles_22 = new SummerWaterParticles2(this, 608, 104);
    springWaterParticles_22.flipX = false;
    springWaterParticles_22.flipY = false;
    waterSparkles.add(springWaterParticles_22);

    // springWaterParticles_23
    const springWaterParticles_23 = new SummerWaterParticles2(this, 592, 88);
    springWaterParticles_23.flipX = false;
    springWaterParticles_23.flipY = false;
    waterSparkles.add(springWaterParticles_23);

    // springWaterParticles_24
    const springWaterParticles_24 = new SummerWaterParticles2(this, 592, 72);
    springWaterParticles_24.flipX = false;
    springWaterParticles_24.flipY = false;
    waterSparkles.add(springWaterParticles_24);

    // springWaterParticles_25
    const springWaterParticles_25 = new SummerWaterParticles2(this, 592, 56);
    springWaterParticles_25.flipX = false;
    springWaterParticles_25.flipY = false;
    waterSparkles.add(springWaterParticles_25);

    // springWaterParticles_26
    const springWaterParticles_26 = new SummerWaterParticles2(this, 544, 200);
    springWaterParticles_26.flipX = false;
    springWaterParticles_26.flipY = false;
    waterSparkles.add(springWaterParticles_26);

    // springWaterParticles_27
    const springWaterParticles_27 = new SummerWaterParticles2(this, 496, 264);
    springWaterParticles_27.flipX = false;
    springWaterParticles_27.flipY = false;
    waterSparkles.add(springWaterParticles_27);

    // springWaterParticles_28
    const springWaterParticles_28 = new SummerWaterParticles2(this, 416, 424);
    springWaterParticles_28.flipX = false;
    springWaterParticles_28.flipY = false;
    waterSparkles.add(springWaterParticles_28);

    // springWaterParticles_29
    const springWaterParticles_29 = new SummerWaterParticles2(this, 416, 440);
    springWaterParticles_29.flipX = false;
    springWaterParticles_29.flipY = false;
    waterSparkles.add(springWaterParticles_29);

    // springWaterParticles_30
    const springWaterParticles_30 = new SummerWaterParticles2(this, 400, 440);
    springWaterParticles_30.flipX = false;
    springWaterParticles_30.flipY = false;
    waterSparkles.add(springWaterParticles_30);

    // springWaterParticles_31
    const springWaterParticles_31 = new SummerWaterParticles2(this, 384, 472);
    springWaterParticles_31.flipX = false;
    springWaterParticles_31.flipY = false;
    waterSparkles.add(springWaterParticles_31);

    // springWaterParticles_32
    const springWaterParticles_32 = new SummerWaterParticles2(this, 256, 440);
    springWaterParticles_32.flipX = true;
    springWaterParticles_32.flipY = true;
    waterSparkles.add(springWaterParticles_32);

    // springWaterParticles_33
    const springWaterParticles_33 = new SummerWaterParticles2(this, 368, 200);
    springWaterParticles_33.flipX = false;
    springWaterParticles_33.flipY = false;
    waterSparkles.add(springWaterParticles_33);

    // mentor
    const mentor = new Mentor1(this, 160, 64);
    this.add.existing(mentor);

    // worldNode_6
    const worldNode_6 = new WorldNode(this, 464, 96);
    this.add.existing(worldNode_6);

    // worldNode_7
    const worldNode_7 = new WorldNode(this, 296, 280);
    this.add.existing(worldNode_7);

    // worldNode_8
    const worldNode_8 = new WorldNode(this, 112, 320);
    this.add.existing(worldNode_8);

    // worldNode_9
    const worldNode_9 = new WorldNode(this, 72, 128);
    this.add.existing(worldNode_9);

    // worldNode (prefab fields)
    worldNode.NPCLevelId = 4;

    // worldNode_1 (prefab fields)
    worldNode_1.NPCLevelId = 4;
    worldNode_1.NPCId = 1;

    // worldNode_2 (prefab fields)
    worldNode_2.NPCLevelId = 4;
    worldNode_2.NPCId = 2;

    // worldNode_3 (prefab fields)
    worldNode_3.NPCLevelId = 4;
    worldNode_3.NPCId = 3;

    // worldNode_4 (prefab fields)
    worldNode_4.NPCLevelId = 4;
    worldNode_4.NPCId = 4;

    // worldNode_5 (prefab fields)
    worldNode_5.NPCLevelId = 4;
    worldNode_5.NPCId = 5;

    // worldNode_6 (prefab fields)
    worldNode_6.NPCLevelId = 4;
    worldNode_6.NPCId = 5;

    // worldNode_7 (prefab fields)
    worldNode_7.NPCLevelId = 4;
    worldNode_7.NPCId = 5;

    // worldNode_8 (prefab fields)
    worldNode_8.NPCLevelId = 4;
    worldNode_8.NPCId = 5;

    // worldNode_9 (prefab fields)
    worldNode_9.NPCLevelId = 4;
    worldNode_9.NPCId = 5;

    this.player = player;
    this.portal = portal;
    this.mentor = mentor;
    this.forest_biome_6 = forest_biome_6;

    this.events.emit('scene-awake');
  }

  private player!: Player;
  private portal!: Portal;
  private mentor!: Mentor1;
  private forest_biome_6!: Phaser.Tilemaps.Tilemap;

  /* START-USER-CODE */

  // Write your code here

  create() {
    this.editorCreate();
    this.initialize({
      camera: this.cameras.main,
      player: this.player,
      tilemap: this.forest_biome_6,
      portal: this.portal,
      mentor: this.mentor,
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
